import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { getProductosByCode } from "../repository";

const SearchByCode = ({actualizarproductos}) => {

  const [equivalencias, setEquivalencias] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [loading, setLoading] = useState(0);
  const [productos, setProductos] = useState([]);
  const [status, setStatus] = useState(null);
  const [hasError, setHasError] = useState(false);

  // Toast configuration
  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });

  useEffect(() => {
    if (productos.length === 0 && status === "success") {
      Swal.fire({
        title: '<span style="font-size: 20px; font-weight: 600;">Búsqueda incompleta</span>',
        html: `
          <p style="font-size: 14px; margin-bottom: 12px;">No se encontraron productos con ese código.</p>
          <p style="font-size: 14px; margin-bottom: 8px;"><strong>Sugerencias:</strong></p>
          <p style="font-size: 14px; margin: 3px 0;">• Verifica que el código sea correcto</p>
          <p style="font-size: 14px; margin: 3px 0;">• Intenta con "Procesar Equivalencias"</p>
        `,
        showCloseButton: false,
        confirmButtonText: "Entendido",
        confirmButtonColor: "#f7a209",
        width: "340px",
        padding: "1.5em",
      });
    }
  }, [productos, status]);

  const toggleEquivalencias = () => {
    setEquivalencias(!equivalencias);
  };
      
  //Search Products
  const search = (e) => {
    e.preventDefault();
    setProductos([]);
    setStatus(null);

    // Validación: campo no vacío
    if (!codigo || codigo.trim() === "") {
      setHasError(true);
      Toast.fire({
        icon: "warning",
        text: "Ingresa un código de producto",
      });
      return;
    }

    setLoading(1);
    setHasError(false);
    actualizarproductos([]);

    getProductosByCode(codigo, equivalencias ? 1 : 0)
      .then((response) => {
        if (response.status === "success") {
          setStatus("success");
          setProductos(response.result);
          actualizarproductos(response.result);
          setLoading(0);
        } else {
          setLoading(0);
          Swal.fire({
            text: "Error al obtener la información.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch((err) => {
        setLoading(0);
        Swal.fire({
          text: "Error al obtener la información.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        });
      });
  };
    return (
      <div>
        {/* CONTENT */}
        <section id="searchContent" className="mt-3">
          <form onSubmit={search}>
            <div className="container">
              <div className="row align-items-center justify-content-center">
                <div className="col-12 col-sm-auto mb-2 mb-sm-0">
                  <h6 className="mb-0">Código:</h6>
                </div>
                <div className="col-12 col-sm-6 col-md-3 mb-2">
                  <input
                    name="txtCodigo"
                    type="text"
                    className="form-control"
                    style={hasError ? {
                      borderColor: "#dc3545",
                      boxShadow: "0 0 0 0.2rem rgba(220, 53, 69, 0.25)",
                      animation: "shake 0.5s"
                    } : {}}
                    defaultValue={codigo}
                    autoComplete="off"
                    placeholder="Capture el Código"
                    onChange={(e) => { setCodigo(e.target.value); setHasError(false); setProductos([]); setStatus(null); }}
                    maxLength="20"
                  />
                </div>
                <div className="col-12 col-sm-auto mb-2 d-flex align-items-center justify-content-center justify-content-sm-start">
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      name="chkEquivalencias"
                      id="chkEquivalencias"
                      onChange={toggleEquivalencias}
                      checked={equivalencias}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="chkEquivalencias"
                    >
                      Procesar Equivalencias
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-auto mb-2 mt-3 mt-sm-0">
                  <button className="btn btn-secondary w-100" type="submit">
                    <i className="fa fa-search mr-1"></i>Buscar
                  </button>
                </div>
              </div>

              {loading === 1 && (
                <div className="text-center mb-3 mt-3">
                  <h6>Buscando...</h6>
                  <div
                    className="spinner-border text-warning"
                    role="status"
                    aria-hidden="true"
                  ></div>
                </div>
              )}
              {/*
              {status === "success" && (
                <Fragment>
                  <div className="row mt-3">
                    <div className="col-md-3"></div>
                    <div className="col-md-6 text-center">
                      <h6>
                        <span className="badge badge-warning ml-1 mr-1">
                          {productos.length}
                        </span>
                        <small>
                          <strong>Producto(s) encontrado(s)</strong>
                        </small>
                      </h6>
                      <div className="col-md-3"></div>
                    </div>
                  </div>
                  <div className="row">
                    {productos.map((item, index) => (
                      <ProductItem
                        item={item}
                        index={index}
                        add={props.addToCart}
                        key = {index}
                      />
                    ))}
                  </div>
                </Fragment>
              )}
              */}
            </div>
          </form>
        </section>
      </div>
    );
  };

export default SearchByCode;
